// import IMAge from '../../assets/kazuko2.png'
export const Data = [
	{
		title: 'MIB',
		description: 'Co-founder/Comunication Engineer',
		image: './assets2/MIB.jpg',
		twitter:'https://twitter.com/mibr_0',
		instagram:'https://www.instagram.com/m_.ibrahim/',
		linktree: 'https://nametag.org/u/mibr/',
	},
	{
		title: 'RA4',
		description: 'Co-founder',
		image: './assets2/RA4.jpg',
		twitter:'https://twitter.com/MiraSociety?s=09',
		instagram:'https://www.instagram.com/reel/Cc-39YFAfIY/?utm_source=ig_web_button_share_sheet',
		linktree: 'https://linktr.ee/MIRASOCIETYNFT',
	},
	{
		title: 'Lamia Jarrah',
		description: 'Social media manager',
		image: './assets2/Lamia Jarrah.jpg',
		twitter:'https://twitter.com/LamiaJarrah',
		instagram:'https://www.instagram.com/lamia_jarrah/',
		linktree: '',
	},
		{
		title: 'OSCAR',
		description: 'Discord Manger',
		image: './assets2/oscar.jpg',
		twitter:'https://twitter.com/0xoscar',
		instagram:'',
		linktree: '',
	},
// 	{
// 		title: 'Eman',
// 		description: 'Website Developer',
// 		image: './assets2/Eman.jpg',
// 		twitter:'https://twitter.com/Eman2799M',
// 		instagram:'https://www.instagram.com/emy.m27_99/',
// 		linktree: 'https://www.linkedin.com/in/emanmohameda2799/',
// 	},
	{
		title: 'Simon',
		description: 'Blockchain Developer',
		image: './assets2/Simon.jpg',
		twitter:'https://twitter.com/SulimanMuk',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Abdullah Saleh',
		description: 'Community Manager',
		image: './assets2/Abdullah Saleh.jpg',
		twitter:'https://twitter.com/Turs1a',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Mohamed Zehry',
		description: 'Motion Graphics',
		image: './assets2/Mohamed Zehry.jpg',
		twitter:'https://twitter.com/zehry14',
		instagram:'',
		linktree: '',
	},
	{
		title: 'EYAD',
		description: 'Programmer',
		image: './assets2/إياد.jpg',
		twitter:'https://twitter.com/ESM_NFT?s=20&t=XoDMyibGmRCQf-50dAxL8w',
		instagram:'https://instagram.com/eyad_salloume?r=nametag',
		linktree: 'https://www.tiktok.com/@eyad.mira?is_from_webapp=1&sender_device=pc',
	},
	{
		title: 'Nour',
		description: 'Community manager',
		image: './assets2/نور.jpg',
		twitter:'https://twitter.com/nft_nour?s=20&t=OL6TncksD9_iuDhs7hC9Ng',
		instagram:'https://www.instagram.com/nour.4626/?utm_medium=copy_link',
		linktree: '',
	},
	{
		title: 'Ali',
		description: 'Community manager',
		image: './assets2/علي.jpg',
		twitter:'https://twitter.com/TheBullet_25?s=20&t=MKCrpPhm9gxLxZ3HJZmXpg',
		instagram:'https://instagram.com/ali.x51?igshid=YmMyMTA2M2Y=',
		linktree: '',
	},
	{
		title: 'Mashoor Al Harethy',
		description: 'Investor',
		image: './assets2/مشهور الحارثى.jpg',
		twitter:'https://twitter.com/Saudi_inventor?s=09',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Ahmed salih',
		description: 'Investor',
		image: './assets2/Ahmed salih.jpg',
		twitter:'https://mobile.twitter.com/amsaleh87',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Faozia',
		description: 'Investor',
		image:'./assets2/فوزية.jpg',
		twitter:'https://twitter.com/t_almtmyz?s=20&t=GjH_C8ZqTBoTuBLsZnc0iw',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Mohamed fayez',
		description: 'Investor',
		image: './assets2/ANUNNAKI.jpg',
		twitter:'https://twitter.com/Anunnaki_IQ?t=LJHgK1lIe2drXNmNjCelWA&s=08',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Dareen',
		description: 'Investor',
		image: './assets2/دارين.jpg',
		twitter:'https://twitter.com/dada_k777?s=20&t=2tzokMFyaZRigPJEXkAhPw',
		instagram:'https://www.instagram.com/dada_6107/?igshid=YmMyMTA2M2Y=',
		linktree: '',
	},
	{
		title: 'Laila Alsbaee',
		description: 'Investor',
		image: './assets2/ليلى السبيعى.jpg',
		twitter:'',
		instagram:'',
		linktree: 'https://heylink.me/laila.s454/',
	},
	{
		title: ' Maha Alsbaee',
		description: 'Investor',
		image: './assets2/مها السبيعى.jpg',
		twitter:'https://twitter.com/mahaalsubaei6?s=11&t=ldPPmsA-ggoiOL58jrlVOw',
		instagram:'https://instagram.com/maha_alsubaei?r=nametag',
		linktree: '',
	},
	{
		title: 'Abo khaled Al Anzey',
		description: 'Investor',
		image: './assets2/ابو خالد العنزى.jpg',
		twitter:'https://twitter.com/abokalid_mira?s=20&t=PBxzWRyrihRBpHlBos3ZlQ',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Aziz Fadl',
		description: 'Investor',
		image: './assets2/عزيز فاضل.jpg',
		twitter:'',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Zoubida',
		description: 'Investor',
		image: './assets2/Zoubida.jpg',
		twitter:'https://twitter.com/safiluna0302?s=20&t=0Lpo7PHMqYagPE9-QS6RRA',
		instagram:'https://www.instagram.com/desingmilano/?r=nametag',
		linktree: '',
	},
	{
		title: 'Ahmed gafer',
		description: 'Investor',
		image: './assets2/د. احمد جعفر.jpg',
		twitter:'https://twitter.com/DrAhmad_Jaafar',
		instagram:'https://www.instagram.com/dr.ahmad_jaafar',
		linktree: '',
	},
	{
		title: 'Mohamed Al Anzey',
		description: 'Investor',
		image: './assets2/محمد العنزى.jpg',
		twitter:'https://twitter.com/ele_3ksa?s=20&t=gmR7svREjZJ8-xgktCZpog',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Hamza Mahfouz ',
		description: 'Investor',
		image: './assets2/حمزة محفوظ.jpg',
		twitter:'https://twitter.com/hamzaweezly',
		instagram:'',
		linktree: 'https://tapmybio.com/hamzaweezly',
	},
	{
		title: 'Mohamed AL thbeti',
		description: 'Investor',
		image: './assets2/محمد الثبيتى.jpg',
		twitter:'https://twitter.com/Mohammad_Althbi?s=20&t=yw1oY4J72UkFNDpnkAR0xg',
		instagram:'',
		linktree: '',
	},
	{
		title: 'Aml Alsbaee',
		description: 'Investor',
		image: './assets2/امل السبيعى.jpg',
		twitter:'https://mobile.twitter.com/au79amal',
		instagram:'',
		linktree: 'https://heylink.me/amal_80/',
	},
];

export const sliderSettings = {
	arrows: false,
	slidesToShow: 5,
	focusOnselect: false,
	accessability: false,
	responsive: [
		{
			breakpoint: 1180,
			settings: {
				slidesToShow: 3,
			},
		},

		{
			breakpoint: 900,
			settings: {
				slidesToShow: 2,
			},
		},
	],
};
